import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import {BaseService} from "../base-service";
import {Storage} from "@ionic/storage";
import {AppConfig} from "../../config/appconfig";
import {Observable} from "rxjs/Observable";
import {ISensorParameters} from "../../models/reports/ISensorParameters";
import {ISensorData} from "../../models/reports/ISensorData";

/*
  Generated class for the SensorsProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class SensorsProvider extends BaseService {

  private readonly _url: string = AppConfig.apiBaseUrl + "report/sensors";

  constructor(
    public http: Http,
    public storage: Storage
  ) {
    super(http, storage);
  }

  public getCategories(controllerId: number): Observable<any[]>{
    let catsUrl = this._url + "/categories/" + controllerId.toString();
    return this.http.get(catsUrl, {headers: this.headers})
      .map(
        (res: Response) => {
          let data = res ? res.json() : null;
          return data
        }
      );
  }

  public getSensors(controllerId: number, catId: number): Observable<any[]>{
    let sensorsUrl = this._url + "/category/" + catId.toString() + "/" + controllerId.toString();
    return this.http.get(sensorsUrl, {headers: this.headers})
      .map(
        (res: Response) => {
          let data = res ? res.json() : null;
          return data;
        }
      );
  }

  public history(p: ISensorParameters): Observable<ISensorData[]>{
    let historyUrl = this._url + "/history";
    return this.http.post(historyUrl, p, {headers: this.headers})
      .map(
        (res: Response) => {
          let data = res ? res.json() : null;
          return data;
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/providers/sensors/sensors.ts